// extracted by mini-css-extract-plugin
export default {"skill-bar":"SkillBar_skill-bar__XLIO-","info":"SkillBar_info__Ndd9o","bar":"SkillBar_bar__HQiOD","percent":"SkillBar_percent__+7au2","html":"SkillBar_html__Id2Vd"};